
    // IMPORTS
    import { defineComponent } from 'vue';
    import { RouterView } from 'vue-router'

    import PortalPage from '@/components/common/portal-page.vue'

    export default defineComponent({
        name: 'loginPage',

        components: {
            PortalPage,
            RouterView
        }
    });
